import type { Context } from "../context.js";
import type { EmitFn } from "../adapters.js";

/**
 * Intención de salir — multi-dispositivo, una sola señal `exitIntent`:
 *  - Desktop: el cursor sale por el borde superior de la ventana (va a la X / barra).
 *  - Móvil/tablet: scroll RÁPIDO hacia arriba (flick hacia la barra de direcciones /
 *    botón atrás), tras haber leído algo. Es el equivalente táctil del exit-intent.
 */
const UP_VELOCITY = 1.1; // px/ms (~1100 px/s) → solo un flick deliberado, no un scroll lento
const MIN_UP_MOVE = 30; // px mínimos en el gesto
const MIN_DEPTH = 15; // % leído antes de considerar "salida" (evita disparos al cargar)

export function startExitIntent(ctx: Context, emit: EmitFn) {
  function fire() {
    if (ctx.state.exitIntent) return;
    ctx.state.exitIntent = true;
    emit("exit_intent", {});
    ctx.touch();
  }

  // Desktop: cursor fuera por arriba.
  if (ctx.state.device === "desktop") {
    document.addEventListener(
      "mouseout",
      (e: MouseEvent) => {
        if (e.clientY <= 0) fire();
      },
      { passive: true }
    );
  }

  // Táctil (móvil/tablet): flick rápido hacia arriba.
  const touch = ctx.state.device !== "desktop" || "ontouchstart" in window;
  if (touch) {
    let lastY = window.scrollY;
    let lastT = Date.now();
    window.addEventListener(
      "scroll",
      () => {
        const y = window.scrollY;
        const now = Date.now();
        const dt = Math.max(1, now - lastT);
        const dy = lastY - y; // > 0 = subiendo
        lastY = y;
        lastT = now;
        if (dy > MIN_UP_MOVE && dy / dt >= UP_VELOCITY && ctx.state.scrollDepthPct >= MIN_DEPTH) {
          fire();
        }
      },
      { passive: true }
    );
  }
}
